import React from 'react';
import Loading from './Loading';

// Re-export the Loading props interface
export interface SpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  color?: 'primary' | 'secondary' | 'white' | 'gray';
  text?: string;
  fullPage?: boolean;
  className?: string;
}

// Re-export Loading component as Spinner for backward compatibility
const Spinner: React.FC<SpinnerProps> = (props) => {
  return <Loading {...props} />;
};

export default Spinner;